import classNames from "classnames";
import { observer } from "mobx-react";
import { store } from "Models/Store";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import EntityList from "../EntityList/EntityList";
import TablePagination from "../Pagination/TablePagination";
import InlineSpinner from "../Spinner/InlineSpinner";
import { useAppSettingStore } from "./SettingStores/AppSettingPageStore";

export const CreditProviderProductList: React.FunctionComponent = observer(() => {
	const { creditProviderProductStore } = useAppSettingStore();
	const { isLoading, hasError, creditProviderProducts } = creditProviderProductStore;

	const { providerId } = useParams<{ providerId: string }>();

	useEffect(() => {
		if (!!providerId) {
			creditProviderProductStore.setCreditProviderId(providerId);
		}

		return () => {
			creditProviderProductStore.reset();
		}
	}, [providerId, creditProviderProductStore]);
	return (
		<>
			{isLoading && <InlineSpinner />}
			{hasError && creditProviderProducts.length === 0 && (
				<div style={{marginTop: "5px"}} className="alert alert__warning">
					No products available for this credit provider.
				</div>
			)}
			{creditProviderProducts.length > 0 && (
				<div className="collection-component">
					<EntityList
						collection={creditProviderProducts}
						columns={[
							{
								displayName: "Id",
								columnName: "id",
								value: item => item.id,
								hide: true,
							},
							{
								displayName: "Name",
								columnName: "name",
								value: item => item.name,
							},
							{
								displayName: "Product Code",
								columnName: "productCode",
								value: item => item.productCode,
							},
							{
								displayName: "Base Cost",
								columnName: "baseCost",
								value: item => `$${item.baseCost}`,
							},
							{
								displayName: "Description",
								columnName: "description",
								value: item => item.description,
							},
							{
								displayName: "Country Code",
								columnName: "countryCode",
								value: item => !!item.countryCode ? item.countryCode : "N/A",
							},
							{
								displayName: "Is Active",
								columnName: "isActive",
								value: item => (
									<span
										className={classNames("alert-box mini", { error: !item.isActive, success: item.isActive })}
										style={{background: "none"}}
									/>
								),
							},
							{
								displayName: "Active On Create",
								columnName: "activeOnCreate",
								value: item => item.activeOnCreate ? 'TRUE' : 'FALSE'
							}
						]}
						idColumn="id"
						sortColumn="name"
						sortDescending
						onClickRow={item => store.routerHistory.push(`/hub/settings/credit-providers/${creditProviderProductStore.creditProviderId}/products/${item.id}`)}
						
					/>
					{creditProviderProductStore.totalCount > creditProviderProductStore.pageSize && (
						<TablePagination
							perPage={creditProviderProductStore.pageSize}
							pageNo={creditProviderProductStore.pageNo - 1}
							totalRecords={creditProviderProductStore.totalCount}
							onPageChange={pageNo => creditProviderProductStore.setPageNo(pageNo + 1)}
						/>
					)}
				</div>
			)}
		</>
	)
})